<template>
  <div class="wrap" :class="{ 'is-header': $route.meta.header }">
    <!-- Page Header -->
    <transition>
      <page-header
        ref="pageHeader"
        @back-icon-click="handleBack"
        @main-icon-click="handleMain"
        @exit-click="handleExit"
        @close-icon-click="handleClose"
        @search-icon-click="handleSearch"
        @mypage-icon-click="handleMyPage"
        @region-icon-click="handleRegion"
        @share-icon-click="handleShare"
        @knowhow-my-icon-click="handleKnowhowMy"
        @estimate-info-click="estimateInfoClick"
      ></page-header>
    </transition>
    <transition>
      <keepAlive :include="keepAliveList">
        <router-view
          ref="routerView"
          v-keep-scroll-position
          :key="setFullPath"
        ></router-view>
      </keepAlive>
    </transition>
    <!-- dialog -->
    <Dialog />
    <!-- Loading -->
    <Loading />
    <AppUpgradeDialog
      ref="appUpgradeDialog"
      v-if="isNeedAppUpgrade && !isConfirmUpgrade"
    />
    <transition>
      <page-footer
        ref="pageFooter"
        @main-icon-click="handleMain"
        @shops-icon-click="handleShops"
        @community-icon-click="handleCommunity"
        @chat-icon-click="handleChat"
        @mypage-icon-click="handleMyPage"
        @apply-icon-click="handleApply"
        @estimate-icon-click="handleEstimate"
        :chatNew="chatNew"
        :icRequestNew="icRequestNew"
        :mRequestNew="mRequestNew"
      ></page-footer>
    </transition>
    <DesignPopup2
      :show="estimateInfoPopup"
      :data="{
        title: '견적 받은 다음엔?',
        type: 'alert',
        msg: estimateInfoPopupMsg,
      }"
      @close="estimateInfoPopupClose"
    />
  </div>
</template>
<script>
import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import {
  authMapActions,
  authMapGetters,
  authGetters,
  authTypes,
} from '@common/store/modules';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
import Dialog from '@common/components/modal/Dialog';
import Loading from '../common/Loading';
import AppUpgradeDialog from './components/AppUpgradeDialog';
// import MeetDialog from '../../views/user/components/MeetDialog';
import {
  compareVersion,
  isApp,
  checkMobile,
  nativeShareText,
} from '@common/lib/common/utils';

import { mapActions, mapState, mapGetters } from '@common/store/modules/chat';
import * as actions from '@common/store/modules/chat/types';
import * as getters from '@common/store/modules/chat/getters';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  components: {
    PageHeader,
    PageFooter,
    Dialog,
    Loading,
    AppUpgradeDialog,
    DesignPopup2,
  },

  data: () => ({
    transitionName: 'slideRight',
    isConfirmUpgrade: false,
    chatNew: false,
    icRequestNew: false,
    mRequestNew: false,
    quotationNewCnt: 0,
    // component name
    keepAliveList: ['Home', 'MobileMain', 'InternetMain'],
    // 호출 제외 목록
    isRouteName: [
      'Auth.Login',
      'Auth.JoinMobile',
      'Auth.JoinMobileAuth',
      'Auth.JoinGender',
      'Auth.JoinAge',
      'Auth.JoinRegion',
      'Auth.JoinNickname',
      'Home.Intro',
      'Auth.EmailConfirm',
      'Agreement.Terms',
      'news.detail',
      'news',
    ],
    estimateInfoPopup: false,
    estimateInfoPopupMsg: '',
  }),
  computed: {
    ...commonMapGetters({
      appInfo: commonGetters.APPINFO,
    }),
    ...mapGetters({
      chatrooms: getters.CHATROOMS,
    }),
    ...internetMapGetters({
      internetCommercUserQuotationNewList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION_NEW,
    }),
    ...mobileMapGetters({
      mobileEstimateNewCnt: mobileTypes.MOBILE_ESTIMATE_NEW_CNT,
    }),
    isNeedAppUpgrade() {
      const appInfo = this.appInfo;
      if (appInfo) {
        if (appInfo.appVersion && appInfo.serverAppVersion) {
          for (let i = 0; i < appInfo.serverAppVersion.length; i++) {
            const element = appInfo.serverAppVersion[i];
            const chkVersion = compareVersion(
              element.appVersion,
              appInfo.appVersion,
            );
            if (
              appInfo.device === '1' &&
              element.deviceOsType === 'A' &&
              element.appType === 'Customer' &&
              chkVersion
            )
              return true;
            if (
              appInfo.device === '2' &&
              element.deviceOsType === 'I' &&
              element.appType === 'Customer' &&
              chkVersion
            )
              return true;
          }
        }
      }
      return false;
    },
    setFullPath() {
      if (this.$route.name == 'InternetCommerce.GuaranteeConfirm') {
        return this.$route.fullPath;
      } else {
        return this.$route.path;
      }
    },
  },
  // 페이지 이동할때 마다 호출
  async beforeRouteEnter(to, from, next) {
    // console.log('DefaultLayout.vue');
    return next(async vm => {
      await vm.chatFetch();
      await vm.icRequestFetch();
      await vm.mRequestFetch();
    });
  },
  // 디바이스 뒤로가기 눌렀을때 마다 호출
  async beforeRouteUpdate(to, from, next) {
    this.chatFetch();
    this.icRequestFetch();
    this.mRequestFetch();
    next();
  },
  mounted() {},
  methods: {
    ...commonMapActions([
      commonActions.TOGGLE_NAV_DRAWER,
      commonActions.TOGGLE_NAV_MINI,
      commonActions.SET_DIALOG,
      commonActions.HIDE_DIALOG,
    ]),
    ...authMapActions([authTypes.CHECK_AUTH, authTypes.LOGOUT]),
    ...mapActions([actions.FETCH_CHATROOMS]),
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW,
    ]),
    ...mobileMapActions([mobileTypes.SELECT_MOBILE_ESTIMATE_NEW_CNT]),
    handleBack() {
      const name = this.$route.name;
      const hash = this.$route.hash;
      if (name === 'Board.Detail' && hash) {
        this.$router.replace({ name: 'Board.List' });
      } else if (name === 'Knowhow.Detail' && hash) {
        this.$router.replace({ name: 'Knowhow.List' });
      } else {
        this.$router.go(-1);
      }
    },

    handleMain() {
      this.$router.push({ path: '/' }).catch(err => {});
    },

    handleShops() {
      this.$router.push({ path: '/Shops' }).catch(err => {});
    },

    handleCommunity() {
      this.$router.push({ path: '/Community' }).catch(err => {});
    },

    handleChat() {
      this.$router.push({ path: '/Chat' }).catch(err => {});
    },

    handleMyPage() {
      this.$router.push({ path: '/MyPage' }).catch(err => {});
    },
    handleApply() {
      this.$router.push({ name: 'Apply.Main' }).catch(err => {});
    },
    handleEstimate() {
      this.$router.push({ path: '/InternetCommerce/List' }).catch(err => {});
    },
    handleExit() {
      this.$refs.routerView.exitChatroom();
    },
    handleSearch() {
      this.$router.push({ name: 'Search' }).catch(err => {});
    },
    handleClose(linkName) {
      this.$router.push({ name: linkName }).catch(err => {});
    },
    handleRegion(user) {
      // console.log('useruseruser');
      // console.log(user);
      let codeType = 'e';
      let areaId = user.emdAreaId;
      if (user.admName) {
        const admArea = JSON.parse(user.admName);
        areaId = admArea.id;
        codeType = 'a';
      }
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          //areaName: this.user.emdAreaName.split(' ')[2],
          areaName: user.emdAreaName.substring(
            user.emdAreaName.lastIndexOf(' ') + 1,
          ),
          areaFullName: user.emdAreaName,
          areaId,
          codeType,
          from: 'ShopList',
        },
      });
    },
    handleShare() {
      if (!isApp()) {
        if (checkMobile()) {
          const shareData = {
            title: '퍼스',
            text: '퍼스 다운로드',
            // url: 'https://customer.perce.co.kr/Download/App',
            url: 'https://perce.kr/download/app.html',
          };
          navigator.share(shareData);
        }
      } else {
        // nativeShareText(`퍼스 https://customer.perce.co.kr/Download/App`);
        nativeShareText(`퍼스 https://perce.kr/download/app.html`);
      }
    },
    handleKnowhowMy() {
      this.$router.push({ name: 'Knowhow.Mine' }).catch(err => {});
    },
    async chatFetch() {
      if (!this.isRouteName.includes(this.$route.name)) {
        await this[actions.FETCH_CHATROOMS]({
          chatRoomType: 'OneOnOne',
        }).then(() => {
          this.getChatNew();
        });
      }
    },
    getChatNew() {
      this.chatNew = false;
      for (var i = 0; i < this.chatrooms.content.length; i++) {
        if (
          this.chatrooms.content[i].new === true &&
          this.chatrooms.content[i].block === false &&
          this.chatrooms.content[i].leave === false
        ) {
          this.chatNew = true;
          break;
        }
      }
    },
    async icRequestFetch() {
      if (!this.isRouteName.includes(this.$route.name)) {
        await this.getInternetCommerceUserQuotationNew();
        this.quotationNewCnt = this.internetCommercUserQuotationNewList.pagination.totalElements;

        if (this.quotationNewCnt > 0) {
          this.icRequestNew = true;
        }
      }
    },
    async mRequestFetch() {
      if (!this.isRouteName.includes(this.$route.name)) {
        await this.getMobileEstimateNewCnt();

        if (this.mobileEstimateNewCnt > 0) {
          this.mRequestNew = true;
        }
      }
    },
    async getMobileEstimateNewCnt() {
      const params = {};
      await this[mobileTypes.SELECT_MOBILE_ESTIMATE_NEW_CNT](params);
      // console.log('this.mobileEstimateNewCnt');
      // console.log(this.mobileEstimateNewCnt);
    },
    async getInternetCommerceUserQuotationNew() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION_NEW]({
        page: 1,
        size: 10,
      });
      // console.log('this.internetCommercUserQuotationNewList');
      // console.log(this.internetCommercUserQuotationNewList);
    },
    estimateInfoClick(listType) {
      if (listType == 'internet') {
        this.estimateInfoPopupMsg = `마음에 드는 판매점의 견적을 고르고,<br />채팅 상담을 통해<br />가입 신청서를 작성할 수 있어요.`;
      } else {
        this.estimateInfoPopupMsg = `마음에 드는 판매점의 견적을 고르고,<br />채팅 상담을 통해<br />매장 방문약속을 할 수 있어요.`;
      }
      this.estimateInfoPopup = true;
    },
    estimateInfoPopupClose() {
      this.estimateInfoPopup = false;
    },
  },
};
</script>

<style>
button {
  outline: none !important;
}
</style>
